import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
// import { toast } from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import 'react-toastify/dist/ReactToastify.css'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'

const Create = () => {
    const [error, setError] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [inputValue, setInputValue] = useState("");

    const addItem = () => {
        if (inputValue.trim() === "") return;
        setItems([...items, inputValue]);
        setInputValue("");
    };

    const removeItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };


    // Handle image
    const handleImage = event => {
        const file = event.target.files[0]
        if (file) {
            const size = parseInt(file.size) / 1000
            if (size > 500) {
                setError({ ...error, image: 'Select less than 300KB file.' })
                return
            }
            setSelectedFile({ image: file, preview: URL.createObjectURL(file) })
            setError({ ...errors, image: null })
        }
    }

    // Submit Form
    const onSubmit = async (data) => {
        try {
            if (!selectedFile) return setError({ ...error, image: 'Image is required' })
            setLoading(true)
            let formData = new FormData()
            formData.append('name', data.name)
            formData.append('expert', data.expert)
            formData.append("features", JSON.stringify(items));
            formData.append(
                'social',
                JSON.stringify({
                    facebook: data.facebook,
                    instagram: data.instagram,
                    linkedin: data.linkedin,
                })
            );
            formData.append('image', selectedFile.image)

            const response = await Requests.ExpertCounselorsProfile.Store(formData, header)
            if (response) {
                setLoading(false)
                navigate("/dashboard/website/expert-counselors-profile")
            }


        } catch (error) {
            if (error) console.log(error)
        }
    }

    return (
        <div className="store-blog pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Expert Counselors Profile</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/expert-counselors-profile"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    <div className="row">

                                        {/* Image upload Container */}
                                        <div className="form-group mb-4">
                                            {error && error.image ? <p className="text-danger">{error.image}</p> : <p>Image</p>}
                                            <div className="d-flex">
                                                {selectedFile && selectedFile.preview ?
                                                    <div className="img-container text-center mr-2">
                                                        <div className="image border">
                                                            <img src={selectedFile.preview} className="img-fluid" alt="..." />
                                                        </div>
                                                    </div>
                                                    : null}

                                                <div className="img-container text-center">
                                                    <div className="image border">
                                                        <input type="file" className="upload" onChange={handleImage} />
                                                        <div className="flex-center flex-column">
                                                            <Icon icon={plus} size={22} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Name */}
                                        <div className="col-12 col-md-6">
                                            <div className="form-group mb-4">
                                                {errors.name && errors.name.message ? (
                                                    <p className="text-danger">{errors.name && errors.name.message}</p>
                                                ) : <p>Name</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Name"
                                                    {...register("name", { required: "Name is required" })}
                                                />
                                            </div>
                                        </div>

                                        {/* Expert */}
                                        <div className="col-12 col-md-6">
                                            <div className="form-group mb-4">
                                                {errors.expert && errors.expert.message ? (
                                                    <p className="text-danger">{errors.expert && errors.expert.message}</p>
                                                ) : <p>Expert</p>}

                                                <input
                                                    type="text"
                                                    name="expert"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Expert"
                                                    {...register("expert", { required: "Expert is required" })}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Features */}
                                    <div className="form-group mb-4">
                                        {errors.features && errors.features.message ? (
                                            <p className="text-danger">{errors.features && errors.features.message}</p>
                                        ) : <p>Features</p>}

                                        <ul className="list-group mb-3">
                                            {items.map((item, index) => (
                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {item}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => removeItem(index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>

                                        <div style={{ marginTop: "10px", display: "flex", gap: "8px" }}>
                                            <input
                                                type="text"
                                                placeholder="Enter Features"
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                                style={{
                                                    flex: "1",
                                                    padding: "6px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                            <div
                                                onClick={addItem}
                                                className='btn btn-sm btn-danger'
                                            >
                                                Add
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {/* Facebook */}
                                        <div className="col-12 col-md-4">
                                            <div className="form-group mb-4">
                                                {errors.facebook && errors.facebook.message ? (
                                                    <p className="text-danger">{errors.facebook && errors.facebook.message}</p>
                                                ) : <p>Facebook</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="facebook"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Facebook URL"
                                                    {...register("facebook")}
                                                />
                                            </div>
                                        </div>

                                        {/* instagram */}
                                        <div className="col-12 col-md-4">
                                            <div className="form-group mb-4">
                                                {errors.instagram && errors.instagram.message ? (
                                                    <p className="text-danger">{errors.instagram && errors.instagram.message}</p>
                                                ) : <p>Instagram</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="instagram"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter Instagram URL"
                                                    {...register("instagram")}
                                                />
                                            </div>
                                        </div>

                                        {/* linkedin */}
                                        <div className="col-12 col-md-4">
                                            <div className="form-group mb-4">
                                                {errors.linkedin && errors.linkedin.message ? (
                                                    <p className="text-danger">{errors.linkedin && errors.linkedin.message}</p>
                                                ) : <p>LinkedIn</p>
                                                }

                                                <input
                                                    type="text"
                                                    name="linkedin"
                                                    className="form-control shadow-none"
                                                    placeholder="Enter LinkedIn URL"
                                                    {...register("linkedin")}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn shadow-none" disabled={isLoading}>
                                            {isLoading ? 'Creating...' : 'Create'}
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
